var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"date text-small"},[_vm._v("\n  "+_vm._s(_vm.displayedText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }